import { create } from "zustand";

export type SnackBarType = "success" | "error" | "warning";

export type ShowSnackBarOptions = {
  duration?: number;
  type?: SnackBarType;
};

export type SnackBarState = {
  open: boolean;
  message: string;
  type: SnackBarType;
  duration: number;
  showSnackbar: (message: string, options?: ShowSnackBarOptions) => void;
  closeSnackbar: () => void;
};

export const useSnackBar = create<SnackBarState>((set) => ({
  open: false,
  message: "",
  type: "success",
  duration: 3000,
  showSnackbar: (message, options) =>
    set(() => ({
      open: true,
      message,
      duration: options?.duration ?? 3000,
      type: options?.type ?? "success",
    })),
  closeSnackbar: () => set(() => ({ open: false })),
}));

